import { LAYOUTS, ModalAlignmentEnum } from '@voltmoney/types';
import { ROUTE } from '../../routes';
import { WIDGET, } from '@voltmoney/schema';
import { heightMap } from '../../configs/height';
import { ACTION } from './types';
import { applyCustomerFilterAction, goBack } from './action';
import { isMobile } from '../../configs/utils';
export const template = async (height, searchText, filterObj) => ({
    layout: {
        id: ROUTE.CUSTOMER_FILTER_SCREEN,
        type: isMobile() ? LAYOUTS.LIST : LAYOUTS.MODAL,
        style: {
            isPartnerPlatform: true,
            height: heightMap[ROUTE.PAYOUT_DETAILS_SCREEN],
            alignment: ModalAlignmentEnum.RIGHT
        },
        widgets: [
            { id: 'customerFilterScreen', type: WIDGET.CUSTOMER_FILTER_SCREEN_DC }
        ]
    },
    datastore: {
        customerFilterScreen: {
            height,
            filterObj,
            onBackPressAction: {
                type: ACTION.GO_BACK,
                routeId: ROUTE.CUSTOMER_FILTER_SCREEN,
                payload: {},
            },
            applyCustomerFilterAction: {
                type: ACTION.APPLY_CUSTOMER_FILTER_ACTION,
                routeId: ROUTE.CUSTOMER_FILTER_SCREEN,
                payload: { searchText },
            }
        }
    },
});
export const CustomerFilterScreenMf = {
    onLoad: async ({ getHeight, network }, { searchText, filterObj }) => {
        return Promise.resolve(template(getHeight(), searchText, filterObj));
    },
    actions: {
        [ACTION.GO_BACK]: goBack,
        [ACTION.APPLY_CUSTOMER_FILTER_ACTION]: applyCustomerFilterAction,
    }
};
